var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermometer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20q-1.675 0-2.837-1.163Q8 17.675 8 16q0-1.075.55-1.988Q9.1 13.1 10 12.55V6q0-.825.588-1.412Q11.175 4 12 4t1.413.588Q14 5.175 14 6v6.55q.9.55 1.45 1.462.55.913.55 1.988 0 1.675-1.162 2.837Q13.675 20 12 20Zm-1-9.225h2V6q0-.425-.287-.713Q12.425 5 12 5t-.712.287Q11 5.575 11 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometer);
export default __webpack_public_path__ + "static/media/thermometer.2676fb9b0dc25f974e24872b851f159b.svg";
export { ForwardRef as ReactComponent };